// ProductosRoutesXL - Sprint 44 Fase 3 Vista 3.
// Reemplaza el router legacy src/modules/productos/routes.jsx preservando
// EXACTAMENTE las rutas: /productos, /productos/create, /productos/:id/edit.
import { Routes, Route } from 'react-router-dom';
import ProductosListXL from './ProductosListXL';
import ProductoFormXL from './ProductoFormXL';

export default function ProductosRoutesXL() {
  return (
    <Routes>
      <Route index element={<ProductosListXL />} />
      <Route path="create" element={<ProductoFormXL />} />
      <Route path=":id/edit" element={<ProductoFormXL />} />
    </Routes>
  );
}
